import decode from 'jwt-decode';

export default session => {
	const idToken = session.idToken.jwtToken;
	const decodedIdToken = decode(idToken);

	let identities = [];
	if (decodedIdToken.identities && decodedIdToken.identities.length) {
		identities = decodedIdToken.identities.map(identity => identity.providerType);
	}

	return {
		idToken,
		accessToken: session.getAccessToken().getJwtToken(),
		refreshToken: session.getRefreshToken().token,
		exp: decodedIdToken.exp,
		family_name: decodedIdToken.family_name,
		given_name: decodedIdToken.given_name,
		email: decodedIdToken.email,
		birthdate: decodedIdToken.birthdate,
		// "onboardingcomplete" is used only for user redirect back to the drupal site(value from CRM is used on the application pages);
		onboardingcomplete: decodedIdToken['custom:onboarding_status'],
		username: decodedIdToken.sub,
		identities,
		isFirstLogin: decodedIdToken['custom:is_first_login']
	}
};